import { ICopyable } from '../controls/common/icopyable';
import { IListLayout } from './interfaces/list-layout.interface';

export class ListLayout implements IListLayout, ICopyable<IListLayout> {
    public id: number = null;
    public organizationId: string = null;
    public name: string = null;
    isScreenSizeAdapted: boolean = true;
    workflowStepColumnWidth: number = null;
    recordsPerPage: number = null;
    sortAttributeId: number = null;
    sortDirection: string = null;

    public createCopy(): ListLayout {
        const instance = new ListLayout();
        instance.id = this.id;
        instance.organizationId = this.organizationId;
        instance.name = this.name;
        instance.isScreenSizeAdapted = this.isScreenSizeAdapted;
        instance.workflowStepColumnWidth = this.workflowStepColumnWidth;
        instance.recordsPerPage = this.recordsPerPage;
        instance.sortAttributeId = this.sortAttributeId;
        instance.sortDirection = this.sortDirection;
        return instance;
    }

    public static createFormCopy(listLayout: ListLayout): IListLayout {
        const instance = new ListLayout();
        instance.id = listLayout.id;
        instance.organizationId = listLayout.organizationId;
        instance.name = listLayout.name;
        instance.isScreenSizeAdapted = listLayout.isScreenSizeAdapted;
        instance.workflowStepColumnWidth = listLayout.workflowStepColumnWidth;
        instance.recordsPerPage = listLayout.recordsPerPage;
        instance.sortAttributeId = listLayout.sortAttributeId;
        instance.sortDirection = listLayout.sortDirection;
        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.organizationId = other.organizationId;
        this.name = other.name;
        this.isScreenSizeAdapted = other.isScreenSizeAdapted;
        this.workflowStepColumnWidth = other.workflowStepColumnWidth;
        this.recordsPerPage = other.recordsPerPage;
        this.sortAttributeId = other.sortColumn;
        this.sortDirection = other.sortDirection;
    }

    public getDisplayName() {
        return `${this.name}`;
    }
}
